module.exports = __webpack_public_path__ + "687c97bea768311bdb45d13983f5e9b0.mp3"


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/OAM_4.mp3
 ** module id = 178
 ** module chunks = 0
 **/